import { IonSlide } from '@ionic/react';
import * as React from 'react';

import type { ObjectID } from '../../../application/types';
import type { MediaData } from '../../../application/types';
import { useContextTranslation } from '../../translation';
import SwiperWithNavigation from './SwiperWithNavigation';

type BeforeContentSwiperProps = {
  data: {
    id: ObjectID;
    media: MediaData[];
  };
  // SwiperAPI options
  sliderOptions: unknown;
};
const BeforeContentSwiper = ({
  data,
  sliderOptions,
}: BeforeContentSwiperProps): JSX.Element => {
  const t = useContextTranslation('misc');
  const slider = React.useRef<HTMLIonSlidesElement>(null);

  return (
    <SwiperWithNavigation key={data.id} options={sliderOptions} slider={slider}>
      {data.media.map(media => (
        <IonSlide key={media.uri}>
          {media.type === 'video' ? (
            <video
              playsInline
              controls={false}
              src={media.uri}
              muted
              autoPlay
              loop
            />
          ) : (
            <img src={media.uri} alt={t('media')} />
          )}
        </IonSlide>
      ))}
    </SwiperWithNavigation>
  );
};

export default BeforeContentSwiper;
